export default __webpack_public_path__ + "static/Arial-BoldMT-64cdc6e996af77f4f45cc53abc63b53e.woff2";